module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAU5JREFUSA1jYBgFoyFA0xBIT0/Xz8rKksBlCVCOB4itcMmDxJlwSYI0//////SfP3+uAtkG6OoyMjLEgHIngPgoPktwWjBt2rQvQEM3AbEQ0JC9yJbk5uaK/vv3bx9QThuIrwLxJSDGChixikIF09LSWBkZGVcDfeIPFHrHwsLizMzM/PTnz5/7gXyw4ezs7I6TJ09+jcscvBaANKFbAhR6CcSaQHyVkOFANQwELQApglqyDugTHxAfCK4DDbfH53KIMjyRDFMAooGGCQANV0QSE//79680Eh8nE2ckw3SAIhQ5zIFxsgUohxHxMPXoNF4L0A0HhTnQJ0FASzYSawlOCxoaGph+/fq1G2gQSmqZNWvWb6AloWiW4MyMOC149uwZB9BwGSC+gJ5aYJYA5dYCMS8wPsSBNOkAmHq4QD7BpxOU4/HJj8qNhgDlIQAAOLaYE4YysnUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/CourseCenter/img/bread_close_black.png
// module id = 1015
// module chunks = 1